var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatOutlineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9707 21 21 16.9707 21 12C21 7.0293 16.9707 3 12 3C7.02931 3 3.00001 7.0293 3.00001 12C2.99781 13.3906 3.31918 14.7627 3.93871 16.0077C4.10352 16.3259 4.14641 16.6933 4.05931 17.0409L3.52381 19.0443C3.47077 19.2425 3.47082 19.4513 3.52395 19.6495C3.57708 19.8478 3.68142 20.0285 3.82649 20.1737C3.97157 20.3189 4.15228 20.4233 4.35049 20.4766C4.54869 20.5298 4.75742 20.53 4.95571 20.4771L6.95911 19.9407C7.30686 19.8532 7.67466 19.8958 7.9932 20.0604C9.1992 20.6616 10.56 21 12 21Z",
    stroke: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10L8 14",
    stroke: "currentcolor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10L16 14",
    stroke: "currentcolor",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L12 16",
    stroke: "currentcolor",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOutlineIcon);
export default __webpack_public_path__ + "static/media/chat-outline-icon.97c72c278aac0900b68d6a9efc119c78.svg";
export { ForwardRef as ReactComponent };